import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function StockTypeDialog({
  open,
  onClose,
  onSelect,
  options = [
    { value: "retail", label: "สต๊อกย่อย" },
    { value: "pack", label: "แพ็ค" },
  ],
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
        เลือกประเภทสต๊อกที่จะขาย
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 2 }}>
        <Grid container spacing={2} justifyContent="center">
          {options.map((opt) => (
            <Grid item xs={6} key={opt.value}>
              <Paper
                role="button"
                tabIndex={0}
                onClick={() => onSelect?.(opt.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") onSelect?.(opt.value);
                }}
                elevation={2}
                sx={{
                  px: 2,
                  py: 4,
                  textAlign: "center",
                  cursor: "pointer",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: "divider",
                  transition: "all .2s",
                  ":hover": {
                    transform: "translateY(-2px)",
                    boxShadow: 4,
                  },
                  userSelect: "none",
                }}
              >
                <Typography sx={{ fontWeight: 700 }}>{opt.label}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
